//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CashCategorySearchType } from './Enums';

export class CashSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    SearchAmount: number | null = null;
    CashCategoryIDs: string[] = [];
    MaxDate: string | null = null;
    MinDate: string | null = null;
    Payees: string[] = [];
    CategoryTypes: CashCategorySearchType[] = [];
    Payroll: boolean | null = null;
    Transactions: boolean | null = null;

    constructor(initializer?: Partial<CashSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashSearchOptions";
}
